import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Button} from "antd"
import {message} from "antd"
import releaseBasket from "../actions/releaseBasket"
import { deleteBasketPosition } from '../../../services/api/mergerApi'

class ReleaseBasketButton extends Component {
    state = {
        submitting: false
    }

    _handleClickRelease = e => {
        e.preventDefault()

        const r = window.confirm('Bạn có chắc chắn muốn xóa giỏ?')
        if (!r) return false

        return this._releaseBasket()
    }

    _releaseBasket = async () => {
        const {submitting} = this.state

        if (submitting) return false

        this.setState({
            submitting: true
        })

        const {_id} = this.props.basket

        try {
            await releaseBasket(_id)
            await deleteBasketPosition(_id)

            message.success('Xóa giỏ thành công!')

            this.setState({
                submitting: false
            })

            const {onClose, resetPosition} = this.props

            if (typeof onClose === 'function') {
                resetPosition()
                onClose()
            }
        } catch (e) {
            this.setState({
                submitting: false
            })
            message.error(e.message)
        }
    }

    render() {
        const {status} = this.props.basket
        const type = status === 'completed' ? 'primary' : 'secondary'
        const disabled = status === 'completed'

        return (
            <div className="ReleaseBasketButton">
                <Button icon='delete' disabled={!disabled} onClick={this._handleClickRelease} type={type} size="large">Xóa
                    giỏ</Button>
            </div>
        )
    }
}

ReleaseBasketButton.propTypes = {
    onClose: PropTypes.func.isRequired,
    basket: PropTypes.object.isRequired,
}

export default ReleaseBasketButton
